import {ViewPopup} from './ViewPopup'
import {PatchNote} from '../patch_notes/UIPatchNoteModule'
import {PatchNoteView} from '../patch_notes/PatchNoteView'
import {AnnouncementView} from '../patch_notes/AnnouncementView'
import {createLinkIn, setElementInnerHTML, setElementOnClick} from '../ui_utils/DomUtils'
import {TranslationObject} from '@colonist/i18n'
import {clientIntl} from '../ClientI18n.ts'

export class ViewPopupPatchNotes extends ViewPopup {
    constructor(patchNotes: PatchNote[], announcements: string[], removeAction: () => void) {
        const title: TranslationObject = {key: 'strings:popups.patchNote.newUpdate', options: {
            version: patchNotes[0].version,
        }}
        super(title, {key: 'strings:colonistCommon.utils.emptyString'}, () => undefined, () => undefined, true)
        this.makeLarge()

        this.body.style.flexDirection = 'column'
        setElementInnerHTML(this.body, {key: 'strings:colonistCommon.utils.emptyString'})

        // TODO: Remove this class name dependency
        new AnnouncementView({key: 'strings:popups.patchNote.announcement'}, announcements, this.body, 'popup-patchnote-div',
            'popup-patchnote-header-div', 'popup-patchnote-body-div')

        for(const pn of patchNotes) {
            new PatchNoteView(pn, this.body, null, 'popup-patchnote-div', 'popup-patchnote-header-div', 'popup-patchnote-body-div')
        }

        const link = createLinkIn(this.body, `${clientIntl.getLanguagePathPrefix()}/patch-notes`, {key: 'strings:colonistCommon.utils.#buffer', options: {value: 'View All'}}, '')
        setElementOnClick(link, () => this.removePopup())
        link.target = '_blank'
        this.removeXButton()
        this.show()
        this.removeAction = removeAction
    }
}
